import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, Typography, CircularProgress, Button, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { EntityListEnum } from '@beable/roster-backend-client-v1';
import { getStyles } from '../styles';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

interface MetricsModalProps {
    open: boolean;
    // dataRows: SchoolListItem[] | CourseListItem[] | ClassListItem[] | UserListItem[] | ProductDTO[];
    dataRows: Array<any>;
    title: EntityListEnum | undefined;
    handleClose: any;
    isLoading: boolean;
    rowNumbers: number[];
    setPreviousPage: any;
    setNextPage: any;
}

export default function MetricsModal(props: MetricsModalProps) {
  const theme = useTheme();
  const styles = getStyles(theme);
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = useState(getModalStyle);
  // const [filteredRows, setFilteredRows] = useState<Array<any>>([]);

  return (
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={props.open}
        onClose={props.handleClose}
      >
        <Box sx={{ ...modalStyle, ...styles.paper }}>
        <Typography variant="h4">{props.title}</Typography>
        {!props.isLoading && (props.dataRows.length > 98 || props.rowNumbers[0] > 0) ? <Box sx={styles.pageControls}>
          {props.rowNumbers[0] > 0 ? <Button onClick={props.setPreviousPage}>{"<<"}</Button> : null}
          <em>{props.rowNumbers[0] + 1}</em>
          <em> - </em>
          <em>{props.dataRows.length + props.rowNumbers[0] < props.rowNumbers[1] + 1 ? props.rowNumbers[0] + props.dataRows.length : props.rowNumbers[1] + 1}</em>
          {props.dataRows.length > 98 ? <Button onClick={props.setNextPage}>{">>"}</Button> : null}
        </Box> : null}
        {props.isLoading &&
            <Box sx={styles.placeHolder}>
                <CircularProgress disableShrink />
            </Box>}
        {!props.isLoading && props.dataRows.length === 0 &&
            <Typography variant="body1">No data to show</Typography>}
        {!props.isLoading && props.dataRows.length > 0 &&
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  {Object.keys(props.dataRows[0]).map((prop) => {
                      return (prop !== 'id' ? <TableCell align="left">{prop}</TableCell> : <></>)
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                  {props.dataRows.map((row, index) => {
                      return(
                        <TableRow key={index}>
                          {Object.keys(row).map((key) => {
                            return (key !== "id" ? <TableCell align="left">{row[key]}</TableCell> : <></>);
                          })}
                        </TableRow>
                      )
                  })}
              </TableBody>
            </Table>
          </TableContainer>}
          {!props.isLoading && (props.dataRows.length > 98 || props.rowNumbers[0] > 0) ? <Box sx={styles.pageControls}>
              {props.rowNumbers[0] > 0 ? <Button onClick={props.setPreviousPage}>{"<<"}</Button> : null}
              <em>{props.rowNumbers[0] + 1}</em>
              <em> - </em>
              <em>{props.dataRows.length + props.rowNumbers[0] < props.rowNumbers[1] + 1 ? props.rowNumbers[0] + props.dataRows.length : props.rowNumbers[1] + 1}</em>
              {props.dataRows.length > 98 ? <Button onClick={props.setNextPage}>{">>"}</Button> : null}
          </Box> : null}
        </Box>
      </Modal>
  );
}
